const companiesList = {
  listBreadcrumb: "Companies",
  searchPlaceholder: "Search Companies",
  statusFilter: "Status",
  allStatuses: "All",
  createdFrom: "Created from",
  createdTo: "Created to",
  companyName: "Company Name",
  companyId: "ID",
  contactPerson: "Contact Person",
  city: "City",
  countryLabel: "Country",
  createdDate: "Created Date",
  numberOfEvents: "No. of Events",
  status: "Status",
  active: "Active",
  deactivated: "Deactivated",
  pending: "Pending",
  rejected: "Rejected",
  viewDetails: "View Details",
  deactivate: "Deactivate",
  activate: "Activate",
  addCompany: "Add Company",
  noCompaniesTitle: "No Companies Yet",
  noCompaniesDescription:
    "It looks like you haven't added any companies to your list. Get started by creating your first company profile to manage events and applicants.",
  showingRange: "Showing {from}–{to} of {total} companies",
  editPageTitle: "Edit company",
  editPageHint: "Update the company name fields below.",
  nameEn: "Name (EN)",
  nameAr: "Name (AR)",
  companyProfile: "Company Profile",
  overviewTab: "Overview",
  financialsPayrollTab: "Financials & Payroll",
  pendingRequestsTab: "Pending Requests",
  clientsTab: "Clients",
  teamPermissionsTab: "Team & Permissions",
  logsTab: "Logs",
  overviewStatTotalEvents: "Total events",
  overviewStatOngoingEvents: "Ongoing events",
  overviewStatTotalRevenue: "Total revenue",
  overviewStatTotalApplicants: "Total applicants",
  overviewStatCurrency: "SAR",
  editCompanyProfile: "Edit Company Profile",
  generalInformation: "General Information",
  englishName: "English Name",
  arabicName: "Arabic Name",
  cityLabel: "City",
  fullName: "Full Name",
  mobileNumber: "Mobile Number",
  emailAddress: "Email Address",
  commercialRecordLabel: "Commercial Record",
  cannotBeEdited: "Cannot be edited",
  cannotBeEditedEmail: "Cannot be edited",
  documents: "Documents",
  delegationDocument: "Delegation Document",
  idDocument: "ID Document",
  commercialRecordDocument: "Commercial Record (CR Document)",
  download: "Download",
  replace: "Replace",
  removeDocument: "Remove",
  confirmRemoveTitle: "Remove Document",
  confirmRemoveBody: "Are you sure you want to remove this document?",
  logoUploadHint: "JPG, PNG) or SVG. Max 2MB.",
  logoUploadChange: "CHANGE",
  saveChanges: "Save Changes",
  logoUploadFailed: "Logo upload failed. Please try again.",
  commercialRecordUploadFailed:
    "Commercial record upload failed. Please try again.",
  delegationDocumentUploadFailed:
    "Delegation document upload failed. Please try again.",
  idDocumentUploadFailed: "ID document upload failed. Please try again.",
  pendingProfileRequest: "Pending profile request",
  reviewRequest: "Review Request",
  pendingProfileUpdateRequest: "Pending profile update request",
  submittedOn: "Submitted on {date}",
  reviewProfileUpdateRequest: "Review Profile Update Request",
  approveUpdate: "Approve Update",
  rejectUpdateRequest: "Reject Request",
  changesSummary: "Changes Summary",
  changesSummaryLegendNewTitle: "Highlighted fields",
  changesSummaryLegendNewDesc: "Show new values to be updated",
  changesSummaryLegendOldTitle: "Strikethrough text",
  changesSummaryLegendOldDesc: "Show old values to be replaced",
  rejectEditRequestModalTitle: "Reject Edit Request",
  rejectEditRequestModalDescription:
    "Please provide a reason for rejecting this update. This note will be visible to the company administrator.",
  rejectEditRequestReasonLabel: "Reason",
  rejectEditRequestReasonPlaceholder:
    "e.g. Please provide a clearer copy of the documents...",
  confirmRejectEditRequest: "Confirm Rejection",
  totalChanges: "Total Changes",
  totalChangesFields: "{count} fields",
  editRequestLoadError: "Could not load the edit request. Please try again.",
  noActiveEditRequest: "There is no pending profile update request for this company.",
  documentUpdated: "Document updated",
  documentChanges: "Document Changes",
  documentType: "Document Type",
  currentDocument: "Current Document",
  newSubmission: "New Submission",
  previewNew: "Preview New",
  viewCurrent: "View Current",
  viewOldDoc: "View Old Doc",
  noUpdateSubmittedForDocument: "No update submitted for this document",
  requestAccountDeletion: "Request Account Deletion",
};

export default companiesList;
